<template>
  <div class="articlePage pageWhite pagePadding">
    <div class="articleScreen" ref="screenWrap">
      <el-form :model="screenForm" inline ref="screenForm" small>
        <el-form-item label="账号" prop="userName">
          <el-input placeholder="输入账号" v-model="screenForm.userName" clearable style="width: 150px"></el-input>
        </el-form-item>
        <el-form-item label="学校" prop="schoolId">
          <el-select v-model="screenForm.schoolId" filterable clearable>
            <el-option v-for="item in schoolList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="toSubmitScreen">查询</el-button>
          <el-button size="small" @click="toResetScreen">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="articleTable" :style="`height: ${tableHeight}px;`">
      <el-table :data="tableData" stripe header-row-class-name="table-header-bg" ref="applyTable" border
                :max-height="tableHeight" v-loading="isGetting" @selection-change="selectChange"
                @select="tableSelectFlag=false" @select-all="tableSelectFlag=false">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="账号" min-width="120" show-overflow-tooltip prop="userName"></el-table-column>
        <el-table-column label="级别" min-width="120" show-overflow-tooltip prop="role">
          <template slot-scope="scope">{{scope.row.role|role}}</template>
        </el-table-column>
        <el-table-column label="学校" min-width="180" show-overflow-tooltip prop="schoolName"></el-table-column>
        <el-table-column label="最近登录" min-width="150" prop="lastLogin"></el-table-column>
        <el-table-column label="操作" fixed="right" width="175">
          <template slot-scope="scope">
            <el-button size="small" type="primary" plain
                       v-if="userInfo.userName!=scope.row.userName&&scope.row.userName!='admin'"
                       @click="toResetPassword(scope.row)">重置密码
            </el-button>
            <el-button size="small" type="danger" plain
                       v-if="userInfo.userName!=scope.row.userName&&userInfo.userName=='admin'"
                       @click="toDel(scope.row)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="articleFooter">
      <div class="tableSelect">
        <div class="ts-item" v-show="tableSelectArr.length">
          已选<span class="color-primary">{{tableSelectArr.length}}</span>人
          <el-button size="mini" type="danger" @click="toDel('')">删除选中账号</el-button>
        </div>
        <el-button type="primary" size="mini" @click="addDialog=true">添加管理员</el-button>
      </div>
      <el-pagination background @current-change="currentChange" :pager-count="5" :total="totalSize" :page-size="20"
                     layout="total,prev,pager,next,jumper" :current-page="currentPage"></el-pagination>
    </div>
    <add-role :dialogShow="addDialog" @close="addDialog=false" @success="addSuccess()"></add-role>
  </div>
</template>

<script type="text/ecmascript-6">
  import {mapState} from 'vuex'

  const addRole = () => import('@/dialog/addRole')
  export default {
    data () {
      return {
        screenWrap: 50,
        totalSize: 0,
        currentPage: 1, // 当前页码
        tableSelectFlag: false, // 表格数据循环开关
        tableSelectArr: [], // 表格选择数据
        tableSelectAll: {}, // 表格所有选择数据
        tableData: [],
        isGetting: false,
        screenForm: {
          userName: '',
          schoolId: ''
        },
        toScreenForm: {},
        addDialog: false
      }
    },
    computed: {
      ...mapState({
        userInfo: state => state.base.userInfo,
        schoolList: state => state.school.schoolList
      }),
      tableHeight () {
        return window.innerHeight - 142 - this.screenWrap
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.screenWrap = this.$refs.screenWrap.offsetHeight
      })
    },
    created () {
      this._toGetList()
    },
    methods: {
      _toGetList (page) {
        this.isGetting = true
        this.currentPage = page || 1
        this.toScreenForm['page'] = this.currentPage
        this.toScreenForm['size'] = 20
        this.$api.getUser(this.toScreenForm, (res) => {
          this.tableData = res.records
          this.totalSize = (typeof res.total === 'string') ? parseInt(res.total) : res.total
          this.$nextTick(() => {
            this.toMemoryTableSelect()
          })
        }, () => {
          this.isGetting = false
        })
      },
      toSubmitScreen () {
        this.toScreenForm = JSON.parse(JSON.stringify(this.screenForm))
        this._toGetList()
      },
      toResetScreen () {
        this.$refs['screenForm'].resetFields()
        this.toScreenForm = {}
        this._toGetList()
      },
      selectChange (v) { // 表格选择
        this.$nextTick(() => {
          if (!this.tableSelectFlag) {
            this.tableSelectAll['page_' + this.currentPage] = v
            this.tableSelectArr = []
            for (let k in this.tableSelectAll) {
              if (this.tableSelectAll[k] && this.tableSelectAll[k].length > 0) {
                this.tableSelectArr = this.tableSelectArr.concat(this.tableSelectAll[k])
              }
            }
          }
        })
      },
      currentChange (v) { // 分页点击
        this.tableSelectFlag = true // 当只是分页时，不需要去重新循环
        this._toGetList(v)
      },
      // 表格反选
      toMemoryTableSelect () {
        let currentArr = this.tableSelectAll['page_' + this.currentPage]
        if (currentArr && currentArr.length) {
          let dataIDS = this.tableData.map(L => L['sid'])
          currentArr.forEach((o) => {
            if (dataIDS.includes(o['sid'])) {
              this.$refs.applyTable.toggleRowSelection(this.tableData[dataIDS.indexOf(o['sid'])], true)
            }
          })
        }
      },
      // 判断移出表格选中
      toRemoveTableSelect (sid) {
        let oArr = this.tableSelectAll['page_' + this.currentPage] || []
        let nArr = []
        oArr.forEach((o) => {
          if (o.sid !== sid) {
            nArr.push(o)
          }
        })
        this.tableSelectAll['page_' + this.currentPage] = nArr
      },
      // 重置表格选中
      toReset () {
        this.tableSelectAll = {}
        this.tableSelectFlag = false
      },
      addSuccess () {
        this.addDialog = false
        this._toGetList(this.currentPage)
      },
      toDel (obj) {
        if (obj) {
          this.$confirm('确认删除:' + obj.userName + '账号,是否继续?', '删除账号', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$api.delUser(obj['sid'], () => {
              this.toRemoveTableSelect(obj['sid'])
              this.$message.success('删除成功！')
              this._toGetList(this.currentPage)
            })
          }).catch(() => {
          })
        } else {
          let ids = this.tableSelectArr.map(item => item.sid)
          if (ids.length > 0) {
            this.$confirm('确认删除选中这' + ids.length + '个的账号,是否继续?', '批量删除账号', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$api.delUser(ids.join(','), () => {
                this.toReset()
                this.$message.success('删除成功！')
                this._toGetList()
              })
            }).catch(() => {
            })
          }
        }
      },
      toResetPassword (obj) {
        this.$confirm('确认重置' + obj.userName + '的密码(重置后密码为123456),是否继续？', '重置密码', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.passwordUpdate({userID: obj['sid'], new_password: 123456}, res => {
            this.$message.success('重置成功')
          })
        }).catch(() => {
        })
      }
    },
    components: {
      addRole
    },
    filters: {
      role (r) {
        return ['', '超级管理员', '工作人员', '学校管理员'][r]
      }
    }
  }
</script>

<style type="text/scss" lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/main/role.vue